import { createContext } from 'react';
import { TranslateFunc } from '../types';

export const TranslationContext = createContext<{
  translate: TranslateFunc;
  prefix: string;
}>({
  translate: (key) => key,
  prefix: '',
});
